import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Icon from './Icon'

export function Alert ({ children, className, text, type, ...props }) {
  return (
    <div className={cx({ [`alert--${type}`]: type }, className)} {...props}>
      <Icon
        className='cell-align--center'
        iconName={cx({
          check: type === 'success',
          close: type === 'error',
          exclamation: type === 'warning',
          info: type === 'info'
        })}
      />
      {text || children}
    </div>
  )
}

Alert.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string.isRequired
}

export function Brand ({
  children,
  className,
  blue,
  light,
  lightBlue,
  lightGray,
  lightOrange,
  orange,
  variant
}) {
  const classes = cx(
    {
      'brand--blue': blue,
      'brand--light': light,
      'brand--light-blue': lightBlue,
      'brand--light-gray': lightGray,
      'brand--light-orange': lightOrange,
      'brand--orange': orange,
      [`brand--${variant}`]: variant
    },
    className
  )
  return <div className={classes}>{children}</div>
}

Brand.propTypes = {
  children: PropTypes.any,
  className: PropTypes.any,
  blue: PropTypes.bool,
  light: PropTypes.bool,
  lightBlue: PropTypes.bool,
  lightGray: PropTypes.bool,
  lightOrange: PropTypes.bool,
  orange: PropTypes.bool,
  variant: PropTypes.oneOf([
    'blue',
    'light',
    'light-blue',
    'light-gray',
    'light-orange',
    'orange'
  ])
}

export function InlineSpinner ({ isLoading, ...props }) {
  if (!isLoading) {
    return null
  }
  return (
    <Icon
      iconName="spinner"
      {...props}
      className={cx('animate--spin', props.className)}
    />
  )
}

export function ButtonSpinner ({ isLoading, ...props }) {
  if (!isLoading) {
    return null
  }
  return (
    <div className={cx('button__spinner', props.className)}>
      <InlineSpinner {...props} isLoading={isLoading} />
    </div>
  )
}
